import './api/initial';
import './api/auth';
import './api/wallet';
import './api/dapps';
import './api/walletConnectPay';
import './api/swap';
import './api/tokens';
import './api/transfer';
import './api/nfts';
import './api/vesting';
import './api/activities';
import './api/domains';
import './api/settings';
import './api/mfa';
import './api/portfolio';
import './apiUpdates/initial';
import './apiUpdates/activities';
import './apiUpdates/dapp';
import './apiUpdates/walletConnectPay';
import './ui/auth';
import './ui/initial';
import './ui/auth';
import './ui/misc';
import './ui/dapps';
import './ui/walletConnectPay';
import './ui/hardware';
import './ui/settings';
import './ui/nfts';
import './ui/vesting';
import './ui/tokens';
import './ui/transfer';
import './ui/shared';
import './ui/domains';
import './ui/accounts';
import './ui/mfa';
